function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_15",
  "data-name": "Groupe 15",
  transform: "translate(4.677 5.262)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_11",
  "data-name": "Trac\\xE9 11",
  d: "M-2238.264-519.075l-2.308-6.925H-2255l6.925,6.925Z",
  transform: "translate(2270.389 541.389)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_12",
  "data-name": "Trac\\xE9 12",
  d: "M-2214.988-679.844-2217.3-686H-2255l6.156,6.156Z",
  transform: "translate(2255 686)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_13",
  "data-name": "Trac\\xE9 13",
  d: "M-2248.075-343.075h.769l-2.308-6.925H-2255Z",
  transform: "translate(2287.317 382.318)",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_22",
  "data-name": "Rectangle 22",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 49.986,
  height: 50.891,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 48.986,
  height: 49.891,
  rx: 5.5,
  fill: "none"
}));

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_3_2",
    "data-name": "Composant 3 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.986,
    height: 50.891,
    viewBox: "0 0 49.986 50.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.fe1a46e2.svg";
export { ForwardRef as ReactComponent };